/**
 * 指南页
 */
export default function HelpPage() {
  return (
    <div className="min-h-full flex items-center justify-center p-8">
      <p className="text-lg text-default-600">指南尚未开发！</p>
    </div>
  );
}
